import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges Tailwind CSS classes with proper conflict resolution.
 * Combines clsx (conditional classes) with tailwind-merge (Tailwind-aware merging).
 *
 * @example
 * cn('px-2 py-1', isActive && 'bg-blue-500', className)
 * cn('p-4', props.className) // later classes override earlier conflicting ones
 */
export function cn(...inputs: any[]) {
	return twMerge(clsx(inputs));
}
